module.exports = __webpack_public_path__ + "static/Listing-Details-ba222a75af0fcbabd49c0e80b27c968f.jpg";